var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBasicDataMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-basicDataMaintenance"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-basicDataMaintenance",
    clipPath: "url(#clip-icon-basicDataMaintenance)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M313.169,542.932l-.44-1.63A15.06,15.06,0,0,1,313.169,542.932Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 391.54,
    height: 64.022,
    rx: 28,
    transform: "translate(315.858 286.015)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 497.857,
    height: 64.022,
    rx: 28,
    transform: "translate(262.699 428.038)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M968.479,537.731a16.529,16.529,0,0,0-.343-3.213l-2.595-10.163L829.083,200.68a109.774,109.774,0,0,0-101.405-67.131l-434.695.869a109.813,109.813,0,0,0-101.3,67.931L57.143,528.71l-1.566,4.6a16.867,16.867,0,0,0-.777,4.253q-.034.549-.035,1.1V781.024A109.777,109.777,0,0,0,164.574,890.775H858.659a109.774,109.774,0,0,0,109.8-109.751V551.495h.034V538.051A3.1,3.1,0,0,0,968.479,537.731Zm-101.7-4.893H771.43a18.285,18.285,0,0,0-12.8,9.9l-1.84,6.917L725.8,667.123a36.6,36.6,0,0,1-35.383,27.266H354.9a36.613,36.613,0,0,1-35.338-27.026l-32.525-120.1-.5-1.863a18.3,18.3,0,0,0-17.389-12.564H154.285a18.257,18.257,0,0,1-11.467-16.189l4.676-13.044L248.339,222.859A36.607,36.607,0,0,1,282.7,198.634l454.93-1.041a36.591,36.591,0,0,1,34.435,23.974L876.1,504.828l3.315,9.02c.046.515.069,1.041.069,1.567A18.289,18.289,0,0,1,866.776,532.838Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M909.339,534.592v.28a2.618,2.618,0,0,0-.01-.28Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasicDataMaintenance);
export default __webpack_public_path__ + "static/media/icon-basicDataMaintenance.7b932ce811a4812c2c9507d2ee9a78ae.svg";
export { ForwardRef as ReactComponent };